import Vue from 'vue';
import Vuex from 'vuex';
import pageCache from './modules/pageCache.js';
import permission from './modules/permission';
import user from './modules/user';
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    pageCache,
    permission,
    user
  }
})
